import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { LoadAvatarsSuccess, SetLoadAvatarsError, LoadAvatars } from './avatar.actions';
import { Store } from '@ngrx/store';
import { getAvatars, getActiveAvatars } from './avatar.selectors';
import { SetActiveSchema } from '../schema/schema.actions';
import { AvatarApiError, AvatarApiErrorTypes } from './avatar.errors';

@Injectable()
export class AvatarEffects {
  public lazyLoadAvatars$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetActiveSchema),
      withLatestFrom(this.store.select(getAvatars)),
      filter(([, avatars]) => avatars.length === 0),
      map(() => LoadAvatars()),
    ),
  );

  public loadAvatars$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadAvatars),
      switchMap(() =>
        this.store.select(getActiveAvatars).pipe(
          map((avatars) => LoadAvatarsSuccess({ avatars })),
          catchError((err) =>
            of(
              SetLoadAvatarsError({
                error: new AvatarApiError(AvatarApiErrorTypes.LoadAvatarError, err.error.error),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private store: Store<any>) {}
}
